<template>
    <vx-card id="loader">
        <h3>Просмотр и модерация пользователей</h3>

        <h5 class="mt-4">Фильтры</h5>

        <div class="vx-row mt-3 mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.email" v-on:keyup.enter="loadUsers()" autocomplete="off" label="По логину"
                        placeholder="Введите логин..." class="mt-1 w-full" />
                </div>
            </div>

            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="vs-input--label"> По статусу </label>
                    <v-select :options="dicts.statuses" label="name" placeholder="Выберите статус" class="w-full"
                        v-model="form.status"> </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mt-3 mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.firstName" v-on:keyup.enter="loadUsers()" autocomplete="off"
                        label="По имени" placeholder="Введите имя..." class="mt-1 w-full" />
                </div>
            </div>

            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input v-model="form.lastName" v-on:keyup.enter="loadUsers()" autocomplete="off"
                        label="По фамилии" placeholder="Введите фамилию..." class="mt-1 w-full" />
                </div>
            </div>
        </div>

        <div class="vx-row mt-3 mb-2">
            <div class="vx-col w-1/2 mb-1">
                <div class="mt-1 vx-col">
                    <label class="vs-input--label"> Тип аккаунта </label>
                    <v-select :options="dicts.userTypes" label="name" placeholder="Выберите тип аккаунта" class="w-full"
                        v-model="form.userType">
                    </v-select>
                </div>
            </div>

            <div class="vx-col w-1/4 mb-1">
                <div class="mt-1 vx-col">
                    <label class="vs-input--label"> Тип обслуживания </label>
                    <v-select :options="dicts.userServiceTypes" label="name" placeholder="Выберите тип обслуживания"
                        class="w-full" v-model="form.userServiceType">
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/4 mb-1">
                <div class="mt-1 vx-col">
                    <label class="vs-input--label"> Тип сверки статистики </label>
                    <v-select :options="dicts.statisticReconciliationTypes" label="name"
                        placeholder="Выберите тип сверки статистики" class="w-full"
                        v-model="form.statisticReconciliationType">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mt-3 mb-2">
            <div class="vx-col w-1/2 mb-1">
                <div class="mt-1 vx-col">
                    <label class="vs-input--label"> Тип пользователя (аккаунтинг) </label>
                    <v-select :options="dicts.userManagementTypes" label="name" placeholder="Выберите тип пользователя"
                        class="w-full" v-model="form.userManagementType">
                    </v-select>
                </div>
            </div>

            <div class="vx-col w-1/2 mb-1">
                <div class="mt-1 vx-col">
                    <label class="vs-input--label"> Статус пользователя (аккаунтинг) </label>
                    <v-select :options="dicts.userManagementStatuses" label="name"
                        placeholder="Выберите статус пользователя" class="w-full" v-model="form.userManagementStatus">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mt-3 mb-2">
            <div class="vx-col w-1/4 mb-1">
                <div class="mt-1 vx-col">
                    <label class="vs-input--label"> Роль </label>
                    <v-select :options="dicts.roles" label="name" placeholder="Выберите роль" class="w-full"
                        v-model="form.role"> </v-select>
                </div>
            </div>
            <div class="vx-col w-1/4 mb-1">
                <div class="mt-1 vx-col">
                    <label class="vs-input--label"> Фильтр по бренду </label>
                    <v-select :options="dicts.brandTypes" multiple label="name" placeholder="Выберите бренд"
                        class="w-full" v-model="form.brandType">
                    </v-select>
                </div>
            </div>

            <div class="vx-col w-1/4 mb-1">
                <div class="mt-1 vx-col">
                    <label class="vs-input--label"> Дата регистрации </label>
                    <date-picker range v-model="dateInterval" type="datetime" format="YYYY-MM-DD"
                        placeholder="Интервал времени" :lang="'ru'" :firstDayOfWeek="1" class="date-p w-full">
                    </date-picker>
                </div>
            </div>

            <div class="vx-col w-1/4 mb-1">
                <div class="mt-1 vx-col">
                    <label class="vs-input--label"> Период расходов </label>
                    <date-picker range v-model="usedBalanceInterval" type="datetime" format="YYYY-MM-DD"
                        placeholder="Интервал времени" :lang="'ru'" :firstDayOfWeek="1" class="date-p w-full">
                    </date-picker>
                </div>
            </div>
        </div>

        <div class="vx-row mt-3 mb-2">
            <div class="vx-col w-1/4 mb-1">
                <vs-input v-model="form.utmMedium" autocomplete="off" label="Utm medium"
                    placeholder="Введите utm medium..." class="mt-1 w-full" />
            </div>

            <div class="vx-col w-1/4 mb-1">
                <vs-input v-model="form.utmSource" autocomplete="off" label="Utm source"
                    placeholder="Введите utm source..." class="mt-1 w-full" />
            </div>

            <div class="vx-col w-1/4 mb-1">
                <vs-input v-model="form.utmContent" autocomplete="off" label="Utm content"
                    placeholder="Введите utm content..." class="mt-1 w-full" />
            </div>

            <div class="vx-col w-1/4 mb-1">
                <vs-input v-model="form.utmCampaign" autocomplete="off" label="Utm campaign"
                    placeholder="Введите utm campaign..." class="mt-1 w-full" />
            </div>
        </div>

        <div class="vx-row mt-3 mb-2">
            <div class="vx-col w-1/4 mb-1">
                <vs-input v-model="form.utmTerm" autocomplete="off" label="Utm term" placeholder="Введите utm term..."
                    class="mt-1 w-full" />
            </div>

            <div class="vx-col w-1/4 mb-1">
                <vs-input v-model="form.telegram" autocomplete="off" label="Telegram" placeholder="Введите telegram..."
                    class="mt-1 w-full" />
            </div>

            <div class="vx-col w-1/4 mb-1">
                <div class="mt-1 vx-col">
                    <label class="vs-input--label"> Ответственный менеджер </label>
                    <v-select :options="dicts.responsibleManagers" multiple label="name"
                        placeholder="Выберите ответственного" class="w-full" v-model="form.responsibleManager">
                    </v-select>
                </div>
            </div>

            <div class="vx-col w-1/4 mb-1">
                <div class="mt-1 pt-6">
                    <vs-checkbox class="mt-2" icon="check" color="rgb(38, 187, 174)" v-model="form.unlimited"> Без
                        лимита</vs-checkbox>
                </div>
            </div>
        </div>

        <div class="vx-row mt-1">
            <div class="vx-col w-5/6 mb-1">
                <div class="mt-1">
                    <vs-button class="mt-2" color="success" @click="searchUsers()" type="filled"> Применить </vs-button>
                    <vs-button class="ml-5" color="rgb(250, 130, 80)" @click="downloadCsv()" type="filled"> Скачать CSV
                    </vs-button>
                </div>
            </div>

            <div class="vx-col w-1/6 mb-1">
                <div class="mt-1 pt-3">
                    <v-select :options="dicts.pageSizes" label="name" placeholder="На странице..."
                        class="w-full page-size" v-model="pageSize" :clearable="false" @input="changePageSize()">
                    </v-select>
                </div>
            </div>
        </div>

        <vs-table stripe :data="users" max-items="25" class="mt-5" @sort="handleSort" :sst="true">
            <template slot="header"> </template>
            <template slot="thead">
                <vs-th sort-key="Email"> Логин </vs-th>
                <vs-th sort-key="LastName"> Имя </vs-th>
                <vs-th sort-key="FirstName"> Фамилия </vs-th>
                <vs-th sort-key="PhoneNumber"> Телефон </vs-th>
                <vs-th> Skype </vs-th>
                <vs-th> Telegram </vs-th>
                <vs-th sort-key="CreatedAt"> Регистрация </vs-th>
                <vs-th>
                    Откуда узнал о <br />
                    платформе
                </vs-th>
                <vs-th> Последний вход </vs-th>
                <vs-th sort-key="Balance"> Баланс </vs-th>
                <vs-th sort-key="UsedBalance"> Потрачено </vs-th>
                <vs-th> Валюта </vs-th>
                <vs-th> Статус </vs-th>
                <vs-th> Проверен </vs-th>
                <vs-th> Email подтвержден </vs-th>
                <vs-th> С лимитом </vs-th>
                <vs-th> Проверка KYC </vs-th>
                <vs-th> Роль </vs-th>
                <vs-th> Промокод </vs-th>
                <vs-th> Тип / комиссия </vs-th>
                <vs-th>
                    Тип / статус <br />
                    (аккаунтинг)
                </vs-th>
                <vs-th>
                    Ответственный <br />
                    менеджер
                </vs-th>
                <vs-th> Действия </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.email }}</vs-td>
                    <vs-td>{{ tr.lastName }}</vs-td>
                    <vs-td>{{ tr.firstName }}</vs-td>
                    <vs-td>{{ tr.phoneNumber }}</vs-td>
                    <vs-td>{{ tr.skype }}</vs-td>
                    <vs-td>{{ tr.telegram }}</vs-td>
                    <vs-td>{{ tr.createdAt | moment('DD.MM.YYYY HH:mm') }}</vs-td>
                    <vs-td>{{ getRegistrationSourceName(tr.registrationSourceId) }}</vs-td>
                    <vs-td>{{ tr.lastLoginAt | moment('DD.MM.YYYY HH:mm') }}</vs-td>
                    <vs-td>{{ (tr.balance - tr.usedBalance) | formatNumber(2) }} {{ tr.currencyShort }}</vs-td>
                    <vs-td v-if="form.filterUsedBalance">{{ tr.usedBalanceFiltered | formatNumber(2) }} ₽</vs-td>
                    <vs-td v-else>{{ tr.usedBalance | formatNumber(2) }} {{ tr.currencyShort }}</vs-td>
                    <vs-td>{{ tr.currencyName }}</vs-td>
                    <vs-td>{{ tr.locked ? 'Заблокирован' : 'Активен' }}</vs-td>
                    <vs-td>
                        <vs-checkbox icon="check" color="rgb(38, 187, 174)" v-model="tr.verified"
                            @change="verifyUser(tr.id, tr.verified)"></vs-checkbox>
                    </vs-td>
                    <vs-td>
                        <vs-checkbox disabled icon="check" color="rgb(38, 187, 174)" v-model="tr.emailConfirmed">
                        </vs-checkbox>
                    </vs-td>
                    <vs-td>
                        <vs-checkbox disabled icon="check" color="rgb(38, 187, 174)" v-model="tr.limited">
                        </vs-checkbox>
                    </vs-td>
                    <vs-td>
                        <vs-checkbox v-if="isKycCheckboxVisible(tr.brandTypeId)" icon="check" color="rgb(38, 187, 174)"
                            v-model="tr.isKycChecked" @change="changeUserKycStatus(tr.id, tr.isKycChecked)">
                        </vs-checkbox>
                    </vs-td>
                    <vs-td>
                        <div v-if="!tr.roleEdit">
                            <feather-icon v-if="isEditRolesAvailable()" icon="Edit2Icon" @click="tr.roleEdit = true"
                                class="inline-block mr-2 cursor-pointer text-warning" svgClasses="w-7 h-7" />
                            {{ tr.roles.join(', ') }}
                        </div>
                        <div v-if="!!tr.roleEdit" class="vx-col w-full" style="max-width: 250px">
                            <v-select multiple :options="dicts.roles" :clerable="false" label="name"
                                placeholder="Не выбрано" class="w-full" v-model="form.roles[indextr]"
                                :reduce="(r) => r.name" @input="changeRole(tr.id, form.roles[indextr])">
                            </v-select>
                        </div>
                    </vs-td>
                    <vs-td>
                        {{ tr.promoCode }}
                        <br />
                        {{ tr.promoCodeActivationDate | moment('DD.MM.YYYY HH:mm') }}
                    </vs-td>
                    <vs-td>
                        {{ tr.userTypeName }}
                        <br />
                        {{ tr.userTypeId ? `${tr.commissionAgency}%` : '' }}
                    </vs-td>
                    <vs-td>
                        {{ tr.userManagementTypeName }}
                        <br />
                        <div v-if="!tr.umStatusEdit">
                            <feather-icon icon="Edit2Icon" @click="tr.umStatusEdit = true"
                                class="inline-block mr-2 cursor-pointer text-warning" svgClasses="w-7 h-7" />
                            {{ tr.userManagementStatusName }}
                        </div>
                        <div v-if="!!tr.umStatusEdit">
                            <div class="vx-col w-full" style="max-width: 250px">
                                <label>
                                    <select @change="changeUserManagementStatus(tr.id)" :id="`um-status-${tr.id}`">
                                        <option :selected="tr.userManagementStatusId == v.id" :key="v.id" :value="v.id"
                                            v-for="v in dicts.userManagementStatuses">
                                            {{ v.name }}
                                        </option>
                                    </select>
                                </label>
                            </div>
                        </div>
                    </vs-td>
                    <vs-td>
                        {{ tr.responsibleManagerEmail }}
                    </vs-td>
                    <vs-td>
                        <div class="inline-block">
                            <router-link :to="{ name: 'user-edit', params: { id: tr.id } }">
                                <vx-tooltip text="Редактировать пользователя" position="top" delay=".3s">
                                    <feather-icon icon="Edit2Icon" class="inline-block mr-2" svgClasses="w-7 h-7" />
                                </vx-tooltip>
                            </router-link>
                        </div>
                        <div class="inline-block">
                            <router-link :to="{ name: 'user-reset', params: { id: tr.id } }">
                                <vx-tooltip text="Сбросить пароль" position="top" delay=".3s">
                                    <feather-icon icon="KeyIcon" class="inline-block mr-2 text-warning"
                                        svgClasses="w-7 h-7" />
                                </vx-tooltip>
                            </router-link>
                        </div>
                        <div v-if="!tr.locked" class="inline-block cursor-pointer">
                            <vx-tooltip text="Заблокировать пользователя" position="top" delay=".3s">
                                <feather-icon @click="showBlockModal(tr)" icon="XCircleIcon"
                                    class="inline-block mr-2 text-danger" svgClasses="w-7 h-7" />
                            </vx-tooltip>
                        </div>
                        <div v-if="tr.locked" class="inline-block cursor-pointer">
                            <vx-tooltip text="Разблокировать пользователя" position="top" delay=".3s">
                                <feather-icon @click="showUnblockModal(tr)" icon="PlayIcon"
                                    class="inline-block mr-2 text-success" svgClasses="w-7 h-7" />
                            </vx-tooltip>
                        </div>
                        <div class="inline-block cursor-pointer" @click="showComments(tr)">
                            <vx-tooltip text="Комментарии">
                                <feather-icon icon="MessageSquareIcon" class="inline-block mr-2 text-gray"
                                    svgClasses="w-7 h-7" />
                            </vx-tooltip>
                        </div>
                        <div v-if="!tr.locked && isAdvertiser(tr)" class="inline-block cursor-pointer">
                            <vx-tooltip text="Перейти в ЛК" position="top" delay=".3s">
                                <feather-icon @click="loginAsUser(tr)" icon="ArrowRightCircleIcon"
                                    class="inline-block mr-2" svgClasses="w-7 h-7" />
                            </vx-tooltip>
                        </div>
                        <div v-if="tr.userUtm" class="inline-block cursor-pointer">
                            <vx-tooltip text="UTM-метки" position="top" delay=".3s">
                                <feather-icon @click="showUtmModal(tr)" icon="HelpCircleIcon"
                                    class="inline-block mr-2 text-gray" svgClasses="w-7 h-7" />
                            </vx-tooltip>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-pagination :max="10" :total="pagesTotal" v-model="page"></vs-pagination>

        <sweet-modal ref="blockModal" icon="error" title="Блокирование пользователя">
            <div class="mb-5">Вы действительно хотите заблокировать пользователя {{ selectedUser.email }}?</div>

            <vs-button class="" color="danger" @click="blockUser(selectedUser)" type="filled"> Заблокировать
                пользователя
            </vs-button>
        </sweet-modal>
        <sweet-modal ref="unblockModal" icon="success" title="Блокирование пользователя">
            <div class="mb-5">Вы действительно хотите разблокировать пользователя {{ selectedUser.email }}?</div>

            <vs-button class="" color="success" @click="unblockUser(selectedUser)" type="filled"> Разблокировать
                пользователя
            </vs-button>
        </sweet-modal>
        <sweet-modal ref="utmModal" title="UTM-метки пользователя">
            <ol v-if="selectedUser && selectedUser.userUtm" class="numerable">
                <li><b>UTM term</b> - {{ selectedUser.userUtm.utmTerm }}</li>
                <li><b>UTM medium</b> - {{ selectedUser.userUtm.utmMedium }}</li>
                <li><b>UTM source</b> - {{ selectedUser.userUtm.utmSource }}</li>
                <li><b>UTM content</b> - {{ selectedUser.userUtm.utmContent }}</li>
                <li><b>UTM campaign</b> - {{ selectedUser.userUtm.utmCampaign }}</li>
            </ol>
        </sweet-modal>

        <vs-popup title="Комментарии пользователя" v-if="comments" :active.sync="commentsPopupView">
            <ol class="numerable">
                <li v-for="comment in comments" :key="`comment_item_` + comment.id" class="mb-2">
                    <b>{{ comment.createdAt | moment('DD.MM.YYYY HH:mm') }} - {{ comment.authorName }}</b>
                    <p>{{ comment.comment }}</p>
                </li>
            </ol>

            <div class="mt-5">
                <label class="required" style="font-size: 12px">Добавить комментарий</label>
                <vs-textarea autocomplete="off" v-model="newComment" class="w-full required textarea" />
            </div>

            <vs-button color="success" @click="saveComment(selectedUser)" type="filled"> Добавить </vs-button>
        </vs-popup>
    </vx-card>
</template>


<script>
import Vue from 'vue';
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';
import DatePicker from 'vue2-datepicker';
import vSelect from 'vue-select';
import axios from 'axios';
import qs from 'qs';
import BRAND_TYPES from 'config/brandTypes';
import ROLES from 'config/roles';

export default {
    data() {
        return {
            users: [],
            selectedUser: {},
            edit: false,
            dateInterval: undefined,
            usedBalanceInterval: undefined,
            comments: [],
            commentsPopupView: false,
            newComment: '',
            page: 1,
            pageSize: 25,
            pagesTotal: 1,
            dicts: {
                statuses: [
                    { id: 0, name: 'Активен' },
                    { id: 1, name: 'Заблокирован' }
                ],
                roles: [],
                userTypes: [],
                userServiceTypes: [],
                pageSizes: [25, 50, 100, 200, 500],
                userManagementStatuses: [],
                userManagementTypes: [],
                brandTypes: [],
                registrationSources: [],
                responsibleManagers: [],
                statisticReconciliationTypes: [],
            },
            form: {
                email: '',
                status: '',
                lastName: '',
                firstName: '',
                role: '',
                userType: '',
                userServiceType: '',
                unlimited: false,
                datefrom: undefined,
                dateTo: undefined,
                usedBalanceFrom: undefined,
                usedBalanceTo: undefined,
                filterUsedBalance: false,
                utmTerm: undefined,
                utmMedium: undefined,
                utmSource: undefined,
                utmContent: undefined,
                utmCampaign: undefined,
                userManagementStatus: '',
                userManagementType: '',
                unlimited: false,
                brandType: undefined,
                telegram: undefined,
                responsibleManager: undefined,
                statisticReconciliationTypes: undefined,
                roles: [],
                orderBy: 'Id',
                orderDirection: 'asc'
            },
            kycSupportedBrandTypes: [BRAND_TYPES.adProFex]
        };
    },
    components: {
        vSelect,
        SweetModal,
        SweetModalTab,
        DatePicker
    },
    methods: {
        isEditRolesAvailable() {
            return this.$auth.user().roles.some((role) => [ROLES.admin, ROLES.responsible_manager].includes(role));
        },
        isAdvertiser(tr) {
            return tr.roles.some((role) => role == ROLES.advertiser);
        },
        searchUsers() {
            this.page = 1;
            this.loadUsers();
        },
        loadUsers() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            const params = {
                email: this.form.email,
                lastName: this.form.lastName,
                firstName: this.form.firstName,
                locked: this.form.status ? this.form.status.id == 1 : undefined,
                roleId: this.form.role ? this.form.role.id : undefined,
                typeId: this.form.userType ? this.form.userType.id : undefined,
                serviceTypeId: this.form.userServiceType ? this.form.userServiceType.id : undefined,
                umStatusId: this.form.userManagementStatus ? this.form.userManagementStatus.id : undefined,
                umTypeId: this.form.userManagementType ? this.form.userManagementType.id : undefined,
                page: this.form.unlimited ? '' : this.page,
                size: this.pageSize,
                unlimited: this.form.unlimited,
                dateFrom: this.form.dateFrom,
                dateTo: this.form.dateTo,
                usedBalanceFrom: this.form.usedBalanceFrom,
                usedBalanceTo: this.form.usedBalanceTo,
                utmTerm: this.form.utmTerm,
                utmMedium: this.form.utmMedium,
                utmSource: this.form.utmSource,
                utmContent: this.form.utmContent,
                utmCampaign: this.form.utmCampaign,
                brandTypeIds: this.form.brandType ? this.form.brandType.map((brandType) => brandType.id) : undefined,
                telegram: this.form.telegram,
                responsibleManagerIds: this.form.responsibleManager ? this.form.responsibleManager.map((r) => r.id) : undefined,
                statisticReconciliationTypeId: this.form.statisticReconciliationType ? this.form.statisticReconciliationType.id : undefined,
                orderBy: this.form.orderBy,
                orderDirection: this.form.orderDirection
            };

            this.axios
                .all([
                    this.axios.get('users', {
                        params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { arrayFormat: 'repeat' });
                        }
                    }),
                    this.axios.get('users/count', {
                        params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { arrayFormat: 'repeat' });
                        }
                    }),
                    this.axios.get('users/dicts')
                ])
                .then(
                    axios.spread((users, count, dicts) => {
                        this.users = users.data;
                        this.users.forEach((u) => {
                            Vue.set(u, 'roleEdit', false);
                            Vue.set(u, 'umStatusEdit', false);
                        });
                        this.dicts.roles = dicts.data.roles;
                        this.dicts.userTypes = dicts.data.userTypes;
                        this.dicts.userServiceTypes = dicts.data.userServiceTypes;
                        this.dicts.userManagementStatuses = dicts.data.userManagementStatuses;
                        this.dicts.userManagementTypes = dicts.data.userManagementTypes;
                        this.dicts.brandTypes = dicts.data.brandTypes;
                        this.dicts.registrationSources = dicts.data.registrationSources;
                        this.dicts.responsibleManagers = dicts.data.responsibleManagers;
                        this.dicts.statisticReconciliationTypes = dicts.data.statisticReconciliationTypes;

                        this.pagesTotal = this.form.unlimited ? 1 : Math.floor(count.data / this.pageSize) + 1;
                        this.setRoles();
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка при загрузке списка пользователей.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        showBlockModal(user) {
            this.selectedUser = user;
            this.$refs.blockModal.open();
        },
        blockUser(user) {
            this.$axios({
                method: 'PUT',
                url: 'users/' + user.id + '/lock',
                errors: this.errors,
                success: () => {
                    user.locked = true;
                    this.$refs.blockModal.close();
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно заблокирован.',
                        text: 'Пользователь успешно заблокирован.',
                        color: 'success'
                    });
                },
                catch: (err) => {
                    this.$refs.blockModal.close();
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при блокировании пользователя!',
                        color: 'danger'
                    });
                }
            });
        },
        showUnblockModal(user) {
            this.selectedUser = user;
            this.$refs.unblockModal.open();
        },
        unblockUser(user) {
            this.$axios({
                method: 'PUT',
                url: 'users/' + user.id + '/unlock',
                errors: this.errors,
                success: () => {
                    user.locked = false;
                    this.$refs.unblockModal.close();
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно разблокирован.',
                        text: 'Пользователь успешно разблокирован.',
                        color: 'success'
                    });
                },
                catch: (err) => {
                    this.$refs.blockModal.close();
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при разблокировке пользователя!',
                        color: 'danger'
                    });
                }
            });
        },
        changeRole(userId, roles) {
            if (roles.length < 1) {
                return this.$vs.notify({
                    title: 'Внимание!',
                    text: 'Нужно выбрать хотя бы одну роль!',
                    color: 'warning'
                });
            }
            const roleIds = this.dicts.roles.filter((role) => roles.includes(role.name)).map((r) => r.id);
            if (roleIds) {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.$axios({
                    method: 'PATCH',
                    url: 'users/' + userId + '/role',
                    params: { userId: userId, roleIds: roleIds },
                    errors: this.errors,
                    success: () => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.$vs.notify({
                            title: 'Успешно обновлено',
                            text: 'Роль пользователя успешно обновлена.',
                            color: 'success'
                        });
                    },
                    catch: (err) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        return this.$vs.notify({
                            title: 'Внимание!',
                            text: 'Ошибка при обновлении роли пользователя!',
                            color: 'danger'
                        });
                    },
                    finally: () => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                    }
                });
            }
        },
        changeUserManagementStatus(userId) {
            const selected = document.getElementById(`um-status-${userId}`).value;
            const status = this.dicts.userManagementStatuses.find((r) => r.id == selected);
            if (status) {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.$axios({
                    method: 'PATCH',
                    url: 'accounting/' + userId + '/status',
                    params: { userId: userId, statusId: status.id },
                    errors: this.errors,
                    success: () => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        const user = this.users.find((u) => u.id == userId);
                        const currentTypeId = 1;
                        if (user && user.userManagementTypeId != currentTypeId) {
                            user.userManagementTypeId = currentTypeId;
                            user.userManagementTypeName = 'Current';
                        }
                        this.$vs.notify({
                            title: 'Успешно обновлено',
                            text: 'Статус пользователя успешно обновлен.',
                            color: 'success'
                        });
                    },
                    catch: (err) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        return this.$vs.notify({
                            title: 'Внимание!',
                            text: 'Ошибка при обновлении статуса пользователя!',
                            color: 'danger'
                        });
                    }
                });
            }
        },
        changeUserKycStatus(userId, isKycChecked) {
            this.$axios({
                method: 'PATCH',
                url: 'users/' + userId + '/kyc-check',
                params: { userId: userId, isKycChecked: isKycChecked },
                errors: this.errors,
                success: () => {
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Статус KYC пользователя успешно обновлен.',
                        color: 'success'
                    });
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при обновлении статуса KYC пользователя!',
                        color: 'danger'
                    });
                }
            });
        },
        verifyUser(userId, verified) {
            this.$axios({
                method: 'PATCH',
                url: 'users/' + userId + '/verify',
                params: { userId: userId, verified: verified },
                errors: this.errors,
                success: () => {
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Статус проверки пользователя успешно обновлен.',
                        color: 'success'
                    });
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при обновлении статуса проверки пользователя!',
                        color: 'danger'
                    });
                }
            });
        },
        loginAsUser(user) {
            this.axios
                .post('advertiser/auth/login-as', { email: user.email })
                .then((response) => {
                    const encodedToken = btoa(response.data.auth_token);
                    const uri = process.env.VUE_APP_ADVERTISER_URL + '/login-as?token=' + encodedToken;
                    window.open(uri, '_blank');
                })
                .catch((err) => {
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при переходе в ЛК пользователя!',
                        color: 'danger'
                    });
                });
        },
        showComments(user) {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios
                .get(`accounting/return-users/${user.id}/comments`)
                .then((resp) => {
                    this.comments = resp.data;
                    this.commentsPopupView = true;
                    this.selectedUser = user;
                })
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка загрузки комментариев.' + err.toString(),
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        saveComment(user) {
            if (!this.newComment) {
                return this.$vs.notify({
                    title: 'Внимание!',
                    text: 'Необходимо ввести коментарий.',
                    color: 'danger'
                });
            }

            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'POST',
                url: 'accounting/return-users/' + user.id + '/comments',
                params: { userId: user.id, comment: this.newComment },
                errors: this.errors,
                success: () => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.newComment = '';
                    this.$vs.notify({
                        title: 'Успешно сохранено',
                        text: 'Комментарий успешно сохранен.',
                        color: 'success'
                    });

                    this.showComments(user);
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при сохранении комментария!',
                        color: 'danger'
                    });
                }
            });
        },
        showUtmModal(user) {
            this.selectedUser = user;
            this.$refs.utmModal.open();
        },
        changePageSize() {
            this.page = 1;

            this.loadUsers();
        },
        downloadCsv() {
            const params = {
                email: this.form.email,
                lastName: this.form.lastName,
                firstName: this.form.firstName,
                locked: this.form.status ? this.form.status.id == 1 : null,
                roleId: this.form.role ? this.form.role.id : null,
                typeId: this.form.userType ? this.form.userType.id : null,
                serviceTypeId: this.form.userServiceType ? this.form.userServiceType.id : null,
                unlimited: this.form.unlimited,
                dateFrom: this.form.dateFrom,
                dateTo: this.form.dateTo,
                utmTerm: this.form.utmTerm,
                utmMedium: this.form.utmMedium,
                utmSource: this.form.utmSource,
                utmContent: this.form.utmContent,
                utmCampaign: this.form.utmCampaign,
                usedBalanceFrom: this.form.usedBalanceFrom,
                usedBalanceTo: this.form.usedBalanceTo
            };

            this.axios
                .post('users/get-csv', params, { responseType: 'blob' })
                .then((response) => {
                    const blob = new Blob([response.data], { type: 'application/octet-stream' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    const dateTime = this.$moment().format('YYYY_MM_DD__HH_mm_ss');
                    link.download = `users_${dateTime}.csv`;
                    link.click();
                    URL.revokeObjectURL(link.href);
                })
                .catch(console.error);
        },
        isKycCheckboxVisible(brandTypeId) {
            return this.kycSupportedBrandTypes.indexOf(brandTypeId) > -1;
        },
        getRegistrationSourceName(registrationSourceId) {
            var registrationSource = this.dicts.registrationSources.find((rs) => rs.id == registrationSourceId);
            if (registrationSource) {
                return registrationSource.name;
            }
            return this.dicts.registrationSources.find((rs) => rs.id == 0).name;
        },
        setRoles() {
            for (var index = 0; index < this.users.length; index++) {
                this.form.roles[index] = this.dicts.roles.filter((r) => this.users[index].roles.includes(r.name));
            }
            this.$forceUpdate();
        },
        handleSort(key, direction) {
            if (key == undefined || direction == undefined) {
                this.form.orderBy = undefined;
                this.form.orderDirection = undefined;
                return;
            }

            this.form.orderBy = key;
            this.form.orderDirection = direction;

            this.loadUsers();
        },
    },
    watch: {
        page: function () {
            this.loadUsers();
        },
        dateInterval: function (newTime) {
            if (newTime[0] == null && newTime[1] == null) {
                this.form.dateFrom = '';
                this.form.dateTo = '';
            } else {
                this.form.dateFrom = this.$moment(newTime[0]).format('YYYY-MM-DD HH:mm:ss');
                this.form.dateTo = this.$moment(newTime[1]).format('YYYY-MM-DD HH:mm:ss');
            }
        },
        usedBalanceInterval: function (newTime) {
            if (newTime[0] == null && newTime[1] == null) {
                this.form.usedBalanceFrom = '';
                this.form.usedBalanceTo = '';
                this.form.filterUsedBalance = false;
            } else {
                this.form.usedBalanceFrom = this.$moment(newTime[0]).format('YYYY-MM-DD HH:mm:ss');
                this.form.usedBalanceTo = this.$moment(newTime[1]).format('YYYY-MM-DD HH:mm:ss');
                this.form.filterUsedBalance = true;
            }
        }
    },
    mounted() {
        this.loadUsers();
    },
    beforeCreate() {
        // Установка заголовка вкладки
        document.title = 'Пользователи';
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}

thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}


.page-size {
    max-width: 100px;
    float: right;
}

.vs-pagination--mb {
    justify-content: center !important;
}

.vs-pagination-primary {
    margin-top: 10px;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
    -webkit-transform: none;
}
</style>